import React from "react";

const Footer = () => {
  return (
    <div className="w-full   hidden md:sticky md:bottom-0 md:flex flex-row justify-evenly  mx-auto p-2 ">
      <p className="hidden sm:block sm:text-title-xs-regular">نسخه {import.meta.env.VITE_APP_VERSION}</p>
      <p className="hidden sm:block sm:text-title-xs-regular">
        {" "}
        ۱۴۰۴ @ تمامی حقوق وندا پرداخت برای{" "}
        <span className="text-title-xs-semibold-UL text-secondary-100 cursor-pointer underline">
          گروه کسب و کار وندا
        </span>{" "}
        محفوظ است.{" "}
      </p>
    </div>
  );
};

export default Footer;
